import { gql } from 'graphql-request'

export const GET_MY_CHALLENGE = gql`
  query GetMyChallenge($challengeType: ChallengeType!) {
    getMyChallenge(challengeType: $challengeType) {
      id
      title
      description
      iconUrl
      criteria
      unit
      currentLevel
      currentLevelName
      completed
      nextLevel
      nextLevelName
      nextTarget
      nextRemaining
      maxLevel
      previousTarget
      missionLink
      challengeLevels {
        id
        iconUrl
        isActive
      }
    }
  }
`

export const GET_CHALLENGE = gql`
  query GetChallengeForClient($clientChallengeInput: ClientChallengeInput!) {
    getChallengeForClient(clientChallengeInput: $clientChallengeInput) {
      id
      title
      description
      iconUrl
      criteria
      unit
      currentLevel
      currentLevelName
      completed
      nextLevel
      nextLevelName
      nextTarget
      nextRemaining
      maxLevel
      previousTarget
      missionLink
      challengeLevels {
        id
        iconUrl
        isActive
      }
    }
  }
`
